import React from 'react';
import immutable from 'immutable';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import IconButton from 'material-ui/IconButton';

import DeleteUser from 'images/common/DeleteUser.png';
import DeleteUserHover from 'images/common/DeleteUserHover.png';
import LibraryCreateActions from 'actions/library/LibraryCreateActions';

const iconColors = {
  active: '#00C853',
  inactive: '#DEDEDE',
  data: '#FB9C3E',
  calls: '#3190FF',
};

class ReadOnlyCell extends React.Component {
  // TODO state, mouse event listeners appear to be unused.
  constructor(props) {
    super(props);
    this.state = {hovered: false};
  }

  onMouseEnter = () => this.setState({hovered: true});
  onMouseLeave = () => this.setState({hovered: false});

  render() {
    return (
      <div className="active-cell cell user-active-cell">
        {this.state.hovered ? (
          <CheckIcon color={iconColors.inactive} />
        ) : this.props.value ? (
          <CheckIcon color={iconColors.active} />
        ) : (
          <div>
            {/* We need &nbsp; for something the user can hover over */}
            &nbsp;
          </div>
        )}
      </div>
    );
  }
}

class RemoveCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hovered: false};
    this.onClick = this.onClick.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  onMouseEnter() {
    this.setState({hovered: true});
  }

  onMouseLeave() {
    this.setState({hovered: false});
  }

  onClick() {
    LibraryCreateActions.removeShare(this.props.original.id, this.props.original.type);
  }

  render() {
    const iconButtonStyle = {cursor: 'default', position: 'static'};
    const iconButtonIconStyle = {cursor: 'pointer'};
    return (
      <div className="delete-cell cell">
        {this.state.hovered ? (
          <IconButton style={iconButtonStyle} iconStyle={iconButtonIconStyle}>
            <img
              alt=""
              src={DeleteUserHover}
              onClick={this.onClick}
              onMouseEnter={this.onMouseEnter}
              onMouseLeave={this.onMouseLeave}
            />
          </IconButton>
        ) : this.props.original ? (
          <IconButton style={iconButtonStyle} iconStyle={iconButtonIconStyle}>
            <img
              alt="Delete user"
              src={DeleteUser}
              onClick={this.onClick}
              onMouseEnter={this.onMouseEnter}
              onMouseLeave={this.onMouseLeave}
            />
          </IconButton>
        ) : (
          <div>
            {/* We need &nbsp; for something the user can hover over */}
            &nbsp;
          </div>
        )}
      </div>
    );
  }
}

class CheckCell extends ReadOnlyCell {
  render() {
    return (
      <div className="check-cell cell">
        <CheckIcon color={iconColors.active} />
      </div>
    );
  }
}

class LinkCell extends React.Component {
  render() {
    return (
      <div className="link-cell cell" style={this.props.style}>
        <span style={this.props.spanStyle}>{this.props.value}</span>
      </div>
    );
  }
}

class CheckboxCell extends React.Component {
  onClick = e => {
    const newValue = !this.props.original[this.props.column.accessor];
    LibraryCreateActions.changeField(
      this.props.original.id,
      this.props.original.type,
      newValue,
      this.props.column.id
    );
  };

  render() {
    const disabledName = this.props.column.accessor + '_disabled';
    let disabled = '';
    if (this.props.original[disabledName]) {
      disabled = immutable.Map({cursor: 'disabled'});
    }

    let style = immutable.Map({cursor: 'pointer'});
    style = style.merge(this.props.iconStyle);

    if (disabled) {
      let disabledStyle = {color: 'gray', pointerEvents: 'none'};
      style = style.merge(disabledStyle);
    }
    return (
      <div className="checkbox-cell cell" style={this.props.style}>
        {(() => {
          if (this.props.value) {
            return (
              <i
                className="material-icons color-primary1"
                style={style.toObject()}
                onClick={this.onClick}>
                check_box
              </i>
            );
          } else {
            return (
              <i
                className="material-icons color-icon-gray"
                style={style.toObject()}
                onClick={this.onClick}>
                check_box_outline_blank
              </i>
            );
          }
        })()}
      </div>
    );
  }
}

export default {
  CheckCell: CheckCell,
  CheckboxCell: CheckboxCell,
  LinkCell: LinkCell,
  ReadOnlyCell: ReadOnlyCell,
  RemoveCell: RemoveCell,
};
